import _extends from "@babel/runtime/helpers/extends";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import { translate } from '@haldor/ui';
import { connect } from 'react-redux';
import Moment from 'moment';
import { ROLE_ADMINISTRATOR } from 'constants/roles';
import { deleteAbsence, submitAbsence, updateAbsence } from 'actions/absence';
import { getSchoolAbsence, getSchoolDetails, getSchoolStudents } from 'actions/schools';
import { searchUser } from 'actions/user';
import { setPageTitle } from 'actions/header';
import DatePicker from 'react-datepicker';
import ReportAbsenceForm from 'containers/Forms/Absence/ReportAbsence';
import Modal from 'containers/Modals/Modal';
import Card, { CardsContainer, CardTitle } from 'components/Cards/Card';
import SectionTitle from 'components/Presentation/SectionTitle';
import Redirect from 'components/Redirect/Redirect';
import { Spinner } from 'UI';
import { Button } from '@haldor/ui';

var AbsenceOverview = /*#__PURE__*/function (_Component) {
  _inherits(AbsenceOverview, _Component);

  var _super = _createSuper(AbsenceOverview);

  function AbsenceOverview(props) {
    var _this;

    _classCallCheck(this, AbsenceOverview);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "onDateChange", function (date) {
      _this.setState({
        date: date
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onSubmit", function () {
      _this.setState({
        submitting: true,
        searchDate: _this.state.date
      });

      _this.props.getSchoolAbsence(_this.props.activeSchoolId, encodeURIComponent(_this.state.date.format())).then(function () {
        _this.setState({
          submitting: false
        });
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onSearch", function (event) {
      event.preventDefault();
      var searchString = _this.state.searchString;

      if (searchString.length < 3) {
        return false;
      }

      _this.setState({
        searching: true
      });

      _this.props.searchUser(searchString).then(function () {
        _this.setState({
          searching: false,
          searchedOnce: true
        });
      });
    });

    _defineProperty(_assertThisInitialized(_this), "UNSAFE_componentWillMount", function () {
      _this.props.setPageTitle(_this.props.translate('absence-today'));
    });

    _defineProperty(_assertThisInitialized(_this), "onAbsenceSubmit", function (values) {
      return new Promise(function (resolve, reject) {
        var data = [values];

        if (values.id != null) {
          _this.props.updateAbsence(data).then(function () {
            resolve(1);

            _this.onSubmit();
          })["catch"](function () {
            reject(0);
          });
        } else {
          _this.props.submitAbsence(data).then(function () {
            resolve(1);

            _this.onSubmit();
          })["catch"](function () {
            reject(0);
          });
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onUserClick", function (user, absence) {
      if (absence != null) {
        _this.setState({
          absenceModal: true,
          selectedUser: user,
          selectedAbsence: absence
        });
      } else {
        _this.setState({
          absenceModal: true,
          selectedUser: user,
          selectedAbsence: null
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "closeModal", function () {
      _this.setState({
        absenceModal: !_this.state.absenceModal,
        selectedUser: null,
        selectedAbsence: null
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onDelete", function (id) {
      _this.props.deleteAbsence(id).then(function () {
        _this.closeModal();
      });
    });

    _this.state = {
      absenceModal: false,
      submitting: false,
      date: Moment(),
      searchDate: Moment(),
      schoolId: null,
      selectedUser: null,
      searchString: '',
      searching: false,
      searchedOnce: false,
      admin: null,
      loading: true
    };
    return _this;
  }

  _createClass(AbsenceOverview, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      var school = this.props.user.schools.find(function (school) {
        return school.id == _this2.props.activeSchoolId;
      });

      if (school != null) {
        var isAdmin = school.userRoles.find(function (role) {
          return role.toUpperCase() == ROLE_ADMINISTRATOR;
        });
        this.setState({
          admin: isAdmin != null
        });

        if (isAdmin != null) {
          this.props.getSchoolDetails(school.id);
          this.props.getSchoolStudents(school.id);
          this.props.getSchoolAbsence(school.id, encodeURIComponent(this.state.date.format())).then(function () {
            _this2.setState({
              loading: false
            });
          });
        }
      }
    }
  }, {
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      var _this3 = this;

      if (this.props.activeSchoolId == null && nextProps.activeSchoolId != null) {
        var schoolId = nextProps.activeSchoolId;
        this.setState({
          loading: true
        });
        nextProps.getSchoolDetails(schoolId);
        nextProps.getSchoolStudents(schoolId);
        nextProps.getSchoolAbsence(schoolId, encodeURIComponent(this.state.date.format())).then(function () {
          _this3.setState({
            loading: false
          });
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;

      var _this$props = this.props,
          translate = _this$props.translate,
          students = _this$props.students;
      var _this$state = this.state,
          selectedUser = _this$state.selectedUser,
          selectedAbsence = _this$state.selectedAbsence;

      if (this.props.user == null || this.state.admin == null) {
        return /*#__PURE__*/React.createElement(Spinner, {
          center: true
        });
      }

      if (this.state.admin != null && !this.state.admin) {
        return /*#__PURE__*/React.createElement(Redirect, {
          to: "/"
        });
      }

      var modalTitle = translate('register-absence');

      if (selectedUser != null) {
        modalTitle = translate('manage-absence-for') + ' ' + selectedUser.firstName + ' ' + selectedUser.lastName;
      }

      return /*#__PURE__*/React.createElement("div", {
        className: "overview"
      }, /*#__PURE__*/React.createElement(Modal, {
        isOpen: this.state.absenceModal,
        onClose: this.closeModal,
        title: modalTitle
      }, /*#__PURE__*/React.createElement(ReportAbsenceForm, {
        onModalClose: this.closeModal,
        onSubmit: this.onAbsenceSubmit,
        user: selectedUser,
        absence: selectedAbsence,
        onDelete: this.onDelete
      })), /*#__PURE__*/React.createElement("div", {
        className: "single-section form",
        style: {
          paddingTop: 0
        }
      }, /*#__PURE__*/React.createElement("div", {
        className: "form-row"
      }, /*#__PURE__*/React.createElement("div", {
        className: "form-row-half"
      }, /*#__PURE__*/React.createElement("h3", null, translate('view-absence-for')), /*#__PURE__*/React.createElement(DatePicker, _extends({
        selected: this.state.date,
        onChange: this.onDateChange,
        popperModifiers: {
          preventOverflow: {
            enabled: true
          },
          positionFixed: false
        },
        popperPlacement: "bottom-start",
        showWeekNumbers: true,
        fixedHeight: true,
        previousMonthButtonLabel: "",
        nextMonthButtonLabel: ""
      }, this.state.date)), /*#__PURE__*/React.createElement("div", {
        style: {
          paddingTop: '1rem'
        }
      }, /*#__PURE__*/React.createElement(Button, {
        onClick: this.onSubmit,
        style: {
          minWidth: '160px'
        }
      }, this.state.submitting ? /*#__PURE__*/React.createElement(Spinner, {
        center: true
      }) : null, translate('update')))), /*#__PURE__*/React.createElement("div", {
        className: "clearfix"
      }), /*#__PURE__*/React.createElement("div", {
        style: {
          marginTop: '2rem'
        }
      }), this.state.loading ? /*#__PURE__*/React.createElement(Spinner, {
        center: true
      }) : this.props.reportedAbsence != null ? /*#__PURE__*/React.createElement(CardsContainer, null, this.props.reportedAbsence.length > 0 ? this.props.reportedAbsence.map(function (absence) {
        return /*#__PURE__*/React.createElement(Card, {
          type: "group",
          id: absence.user.userId,
          key: absence.id + absence.reported,
          onClick: function onClick(e) {
            return _this4.onUserClick(absence.user, absence);
          }
        }, /*#__PURE__*/React.createElement("span", {
          className: "color--meta size-12"
        }, absence.user.email), /*#__PURE__*/React.createElement(CardTitle, null, absence.user.firstName, " ", absence.user.lastName), /*#__PURE__*/React.createElement("div", {
          className: "card-meta"
        }, _this4.props.translate(absence.type)), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("div", {
          className: "card-meta"
        }, absence.period ? Moment.utc(absence.startTime).local().format('Do MMMM YYYY') : Moment.utc(absence.startTime).local().format('Do MMMM YYYY - HH:mm')), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("div", {
          className: "card-meta"
        }, absence.period ? Moment.utc(absence.endTime).local().format('Do MMMM YYYY') : Moment.utc(absence.endTime).local().format('Do MMMM YYYY - HH:mm')));
      }) : /*#__PURE__*/React.createElement("div", {
        className: "color--meta text--center weight--bold x"
      }, this.props.translate('no-results'))) : null), /*#__PURE__*/React.createElement("div", {
        style: {
          marginTop: '3rem'
        }
      }), /*#__PURE__*/React.createElement(SectionTitle, null, /*#__PURE__*/React.createElement("span", null, this.props.translate('report-absence-for-student'))), /*#__PURE__*/React.createElement("div", {
        className: "form-row spacing"
      }, /*#__PURE__*/React.createElement("div", {
        className: "form-row-half"
      }, /*#__PURE__*/React.createElement("form", {
        onSubmit: this.onSearch
      }, /*#__PURE__*/React.createElement("input", {
        type: "text",
        value: this.state.searchString,
        onChange: function onChange(e) {
          return _this4.setState({
            searchString: e.target.value
          });
        },
        placeholder: translate('search') + '...'
      }), /*#__PURE__*/React.createElement("div", {
        style: {
          paddingTop: '1rem'
        }
      }, /*#__PURE__*/React.createElement(Button, {
        style: {
          minWidth: '160px'
        },
        disabled: this.state.searchString.length < 3
      }, translate('search'))), /*#__PURE__*/React.createElement("div", {
        className: "clearfix"
      })), /*#__PURE__*/React.createElement("div", {
        className: "clearfix"
      }))), /*#__PURE__*/React.createElement("div", {
        className: "clearfix"
      }), /*#__PURE__*/React.createElement("div", {
        style: {
          marginTop: '2rem'
        }
      }, /*#__PURE__*/React.createElement(CardsContainer, null, this.state.searching ? /*#__PURE__*/React.createElement(Spinner, {
        center: true
      }) : this.props.searchResults != null && this.props.searchResults.length > 0 ? this.props.searchResults.map(function (student) {
        return /*#__PURE__*/React.createElement(Card, {
          type: "group",
          id: student.userId,
          key: "student-".concat(student.userId),
          onClick: function onClick(e) {
            return _this4.onUserClick(student);
          }
        }, /*#__PURE__*/React.createElement("span", {
          className: "color--meta size-12"
        }, student.email), /*#__PURE__*/React.createElement(CardTitle, null, student.firstName, " ", student.lastName));
      }) : this.state.searchedOnce ? /*#__PURE__*/React.createElement("div", {
        className: "color--meta text--center weight--bold x"
      }, this.props.translate('no-results')) : null))), /*#__PURE__*/React.createElement("div", {
        className: "clearfix"
      }));
    }
  }]);

  return AbsenceOverview;
}(Component);

function mapStateToProps(state) {
  return {
    activeSchoolId: state.user.activeSchool,
    translate: translate(state.Languages.translations),
    school: state.School.active,
    user: state.user.currentUser,
    students: state.School.students,
    searchResults: state.user.searchResults,
    reportedAbsence: state.School.absence
  };
}

export default connect(mapStateToProps, {
  getSchoolStudents: getSchoolStudents,
  getSchoolAbsence: getSchoolAbsence,
  getSchoolDetails: getSchoolDetails,
  submitAbsence: submitAbsence,
  updateAbsence: updateAbsence,
  searchUser: searchUser,
  deleteAbsence: deleteAbsence,
  setPageTitle: setPageTitle
})(AbsenceOverview);